import { assertSafeImageUrl } from '@/common/domain/utils/assertSafeImageUrl';

const STORAGE_KEY = 'raptor-document-builder:standalone-branding-logo';

/** Reads a previously uploaded standalone logo URL (session-scoped). */
export function readStandaloneLogoUrl(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    return assertSafeImageUrl(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}

/** Persists a standalone logo URL for reload within the same browser session. */
export function writeStandaloneLogoUrl(url: string | null): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    if (!url) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    const safe = assertSafeImageUrl(url);
    if (!safe) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, safe);
  } catch {
    // Ignore quota / private-mode failures — preview still works for the current session via React state.
  }
}
